import React, { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import Modal from '@gcloud-npm/next12.components.modal';
import { useDispatch, useSelector } from 'react-redux';
import { actions as modalsAction } from '@gcloud-npm/next12.app-controller.reducers-sagas.modals-reducer';
import MetaData from '@gcloud-npm/next12.app-controller.meta-data';
import RouteHandler from '@gcloud-npm/next12.app-controller.route-handler-n';
import ErrorBoundary from '@gcloud-npm/next12.app-controller.error-boundary';
import { actions } from '@gcloud-npm/next12.app-controller.reducers-sagas.main-reducer-n';
import mainSetup from '@/config/mainSetup';
import { wrapper } from '@/store';
import E500 from '@/pages/500';
import '@/styles/globalVars.css';
/* [STYLES] begins */
import '@/styles/price.style.css';
import '@/styles/modal-atencion-emp.style.css';
import '@/styles/picture.style.css';
import '@/styles/modal.style.css';
import '@/styles/lego-component.style.css';
import '@/styles/input-n.style.css';
import '@/styles/image-n.style.css';
import '@/styles/icon-n.style.css';
import '@/styles/icon-label.style.css';
import '@/styles/beach.style.css';
import '@/styles/custom-link.style.css';
import '@/styles/call-4-selling-n.style.css';
import '@/styles/faqs-m.style.css';
import '@/styles/icon.style.css';
import '@/styles/button-m.style.css';
import '@/styles/customizer-component-n.style.css';
import '@/styles/container.style.css';
import '@/styles/form-skeleton.style.css';
import '@/styles/content.style.css';
import '@/styles/call-4-selling.style.css';
import '@/styles/select.style.css';
import '@/styles/tag-link.style.css';
import '@/styles/spin.style.css';
import '@/styles/text-info-n.style.css';
/* [STYLES] ends */

const shouldLoadDyna = (probability = 0) => {
  let res = false;
  let probability2Apply = probability;
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);
    const paramValue = urlParams.get('dyna');
    probability2Apply = parseInt(paramValue, 10);
    res = Math.random() < probability2Apply / 100;
  }
  return res;
};

let ToolBar = null;

const App = ({ Component, pageProps }) => {
  const dispatch = useDispatch();
  const seoInfo = useSelector((state) => state.main.currentSeo);
  const [dynaInjected, setDynaInjected] = useState(false);
  useEffect(() => {
    setDynaInjected(shouldLoadDyna());

    if (`${process.env.NEXT_PUBLIC_GTM_USAGE}` === 'false') {
      document.onvisibilitychange = () => {
        if (document.visibilityState === 'hidden') {
          // console.log('GTM: Enviariamos a analitica');
          dispatch(actions.sendAllCmsEvent());
        }
      };
    }

    if (`${process.env.NEXT_PUBLIC_GTM_USAGE}` === 'false') {
      let timeout = 10000;
      if (window.innerWidth > 400) {
        timeout = 20000;
      }
      window.addEventListener('load', () => {
        setTimeout(() => {
          ((w, d, s, l, i) => {
            w[l] = w[l] || [];
            w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
            var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s),
              dl = l != 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
          })(
            window,
            document,
            'script',
            'dataLayer',
            `${process.env.NEXT_PUBLIC_GTM_ID}`
          );
          // console.log('GTM: loaded and events sended')
          dispatch(actions.sendAllCmsEvent());
        }, timeout);
      });
    }
  }, []);

  // if (`${process.env.NEXT_PUBLIC_ALLOW_EDIT}` === 'true') {
  //   ToolBar = dynamic(() =>
  //     import('@gcloud-npm/next12.components.customizer-component-n/dist/toolbar')
  //   );
  // }

  const handlerModals = (args) => {
    dispatch(modalsAction.addModal(args));
  };

  return (
    <>
      <MetaData seoInfo={seoInfo} />
      {dynaInjected && (
        <Head>
          <script
            src={`https://prod.cms.col.movistar.es/static/js/dynatrace/dyna.js`}
            async="true"
            defer="true"
            crossOrigin="anonymous"
          />
        </Head>
      )}
      <RouteHandler />
      <Modal
        key="app-modal"
        className="app-root"
        projectId={mainSetup.projectId}
        reduxDispatchActions={handlerModals}
      />
      <ErrorBoundary screen={E500}>
        <Component {...pageProps} />
        {ToolBar && <ToolBar />}
      </ErrorBoundary>
    </>
  );
};

export default wrapper.withRedux(App);
